import type { DateTimeFilter } from '~/presentation/ui';

export type { IOrderPageAnalytic } from '@gem-sdk/analytics';

export enum EOrderViewScope {
  PAGE = 'page',
  STORE = 'store',
}

export interface IOrderListingFilters {
  date?: DateTimeFilter;
}
